/** 공용 미니 아이콘 — ModeIcon/TopicIcon과 동일한 라인아트 스타일 (currentColor) */

const common = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

/** 로그아웃 — 문 밖으로 나가는 화살표 (헤더 메뉴) */
export function LogoutIcon({ className = 'h-4 w-4' }: { className?: string }) {
  return (
    <svg {...common} className={className}>
      <path d="M13.5 4H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6.5" />
      <path d="M16 8.5 19.5 12 16 15.5" />
      <path d="M19.5 12H10" />
    </svg>
  );
}

/** 사람 — 헤더 메뉴 (비회원 상태) */
export function PersonIcon({ className = 'h-4 w-4' }: { className?: string }) {
  return (
    <svg {...common} className={className}>
      <circle cx="12" cy="8" r="3.6" />
      <path d="M5 19.5c1.2-3.6 3.8-5.3 7-5.3s5.8 1.7 7 5.3" />
    </svg>
  );
}

/** 아래 화살표(작음) — 드롭다운 표시 */
export function CaretIcon({ className = 'h-3 w-3' }: { className?: string }) {
  return (
    <svg {...common} className={className}>
      <path d="M6.5 9.5 L12 15 L17.5 9.5" />
    </svg>
  );
}

/** 홈 — 홈으로 돌아가기 */
export function HomeIcon({ className = 'h-4 w-4' }: { className?: string }) {
  return (
    <svg {...common} className={className}>
      <path d="M4.5 11.5 L12 4.5 L19.5 11.5" />
      <path d="M6.5 10v8.5h11V10" />
      <path d="M10.5 18.5v-4.5h3v4.5" />
    </svg>
  );
}

/** 뒤로가기 — 부드러운 셰브런 + 여운 라인 */
export function BackIcon({ className = 'h-5 w-5' }: { className?: string }) {
  return (
    <svg {...common} className={className}>
      <path d="M13.5 5.5 L7 12 L13.5 18.5" strokeWidth="2" />
      <path d="M11 12h7" strokeWidth="1.4" opacity="0.55" />
    </svg>
  );
}

/** 공유 — 트레이 + 위로 향하는 화살표 */
export function ShareIcon({ className = 'h-4 w-4' }: { className?: string }) {
  return (
    <svg {...common} className={className}>
      <path d="M4 13v5.5A1.5 1.5 0 0 0 5.5 20h13a1.5 1.5 0 0 0 1.5-1.5V13" />
      <path d="M12 15V4M12 4L7.5 8.5M12 4l4.5 4.5" />
    </svg>
  );
}

/** 벨 — 재촉 알림 */
export function BellIcon({ className = 'h-4 w-4' }: { className?: string }) {
  return (
    <svg {...common} className={className}>
      <path d="M12 4a5.5 5.5 0 0 0-5.5 5.5c0 4-1.5 5.4-2.2 6.2-.3.3-.1.8.4.8h14.6c.5 0 .7-.5.4-.8-.7-.8-2.2-2.2-2.2-6.2A5.5 5.5 0 0 0 12 4z" />
      <path d="M10 19.5a2 2 0 0 0 4 0" />
      <path d="M12 4V2.8" />
    </svg>
  );
}

/** 셔플 — 다시 섞기 (교차 화살표) */
export function ShuffleIcon({ className = 'h-4 w-4' }: { className?: string }) {
  return (
    <svg {...common} className={className}>
      <path d="M4 7h3.2c3.8 0 5.8 10 9.6 10H20" />
      <path d="M4 17h3.2c3.8 0 5.8-10 9.6-10H20" />
      <path d="M17.6 4.6 20 7l-2.4 2.4M17.6 14.6 20 17l-2.4 2.4" />
    </svg>
  );
}

/** 새로고침 — 끊긴 방에 다시 입장 */
export function RefreshIcon({ className = 'h-4 w-4' }: { className?: string }) {
  return (
    <svg {...common} className={className}>
      <path d="M20 12a8 8 0 1 1-2.6-5.9" />
      <path d="M20 4v4.5h-4.5" />
    </svg>
  );
}

/** 이미지 — 이미지로 저장 */
export function ImageIcon({ className = 'h-4 w-4' }: { className?: string }) {
  return (
    <svg {...common} className={className}>
      <rect x="3.5" y="5" width="17" height="14" rx="2.5" />
      <circle cx="9" cy="10" r="1.6" />
      <path d="M5 17.5l4.5-4.5 3 3 3.5-3.5 4.5 4.5" />
    </svg>
  );
}

/** 네이버 로그인 버튼용 "N" 마크 (초록 버튼 위 흰 글자 — currentColor) */
export function NaverIcon({ className = 'h-5 w-5' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
      <path d="M6 4h4.4l3.3 5V4H18v16h-4.4l-3.3-5v5H6V4z" />
    </svg>
  );
}

/** 시계 — 방 유효 시간 안내 */
export function ClockIcon({ className = 'h-4 w-4' }: { className?: string }) {
  return (
    <svg {...common} className={className}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 1.8" />
    </svg>
  );
}

/**
 * 카카오 로그인 버튼용 카카오톡 말풍선 심볼.
 * 색은 currentColor — 카카오 가이드대로 노란 버튼 위에 검정(#191919)으로 표시됨.
 */
export function KakaoIcon({ className = 'h-5 w-5' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
      <path d="M12 3C6.48 3 2 6.48 2 10.8c0 2.79 1.86 5.24 4.65 6.62-.15.53-.98 3.4-1.01 3.62 0 0-.02.17.09.23.11.06.24.01.24.01.3-.04 3.5-2.29 4.05-2.68.63.09 1.29.14 1.98.14 5.52 0 10-3.48 10-7.94S17.52 3 12 3z" />
    </svg>
  );
}

/** 타로 더보기 — 겹친 카드 두 장 + 별 */
export function CardsIcon({ className = 'h-4 w-4' }: { className?: string }) {
  return (
    <svg {...common} className={className}>
      <g transform="rotate(-10 9.5 12)">
        <rect x="4.5" y="5.5" width="9" height="13.5" rx="1.8" />
      </g>
      <g transform="rotate(10 15 12.5)">
        <rect x="10.5" y="6" width="9" height="13.5" rx="1.8" />
      </g>
      <path
        d="M15 10.2 L15.7 12.3 L17.8 13 L15.7 13.7 L15 15.8 L14.3 13.7 L12.2 13 L14.3 12.3 Z"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  );
}
